import React from 'react';
import { useParams } from 'react-router-dom';
import EventApplication from '../components/EventApplication';

const ApplicationPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  
  return (
    <div className="container my-5">
      <h1 className="text-center">Mission Trip Application</h1>
      <p className="text-center text-muted mb-4">
        Apply to join us on our next mission trip. Complete the application form below to get started.
      </p>
      <EventApplication 
        eventId={eventId || 'italy-2026'}
        eventType="OBP Italy 2026"
      />
    </div>
  );
};

export default ApplicationPage;